//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import { TransactionPermissions } from '@/modules/transaction/transaction-permissions';
import moment from 'moment';

import { TransactionModel } from '@/modules/transaction/transaction-model';
const { fields } = TransactionModel;

export default {
  name: 'app-transaction-list-table',

  mounted() {
    this.doFilter();
    this.doMountTable(this.$refs.table);
  },

  data() {
    return {
      filter: '',
      nextPage: 2,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: 'createdAt',
        descending: false,
        // rowsNumber: xx if getting data from a server
      },
      columns: [
        {
          name: 'id',
          field: 'id',
          label: 'entities.transaction.fields.id', 
          align: 'center',
        },
        {
          name: 'amount',
          field: 'amount',
          label: 'entities.transaction.fields.amount',
          align: 'center',
        },
        {
          name: 'type',
          field: 'type',
          label: 'entities.transaction.fields.type',
          align: 'center',
        },
        {
          name: 'dueDate',
          field: 'dueDate',
          label: 'entities.transaction.fields.dueDate',
          align: 'center',
        },
        {
          name: 'description',
          field: 'description',
          label: 'entities.transaction.fields.description',
          align: 'center',
        },
        {
          name: 'paymentMethod',
          field: 'paymentMethod',
          label: 'entities.transaction.fields.paymentMethod',
          align: 'center',
        },
        {
          name: 'createdAt',
          field: 'createdAt',
          label: 'entities.transaction.fields.createdAt',
          align: 'center',
        },
        {
          name: 'action',
          field: 'action',
          label: 'common.action',
          align: 'center',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      rows: 'transaction/list/rows',
      count: 'transaction/list/count',
      loading: 'transaction/list/loading',
      currentUser: 'auth/currentUser',
      currentLanguageCode: 'layout/currentLanguageCode',
      // pagination: 'transaction/list/pagination',
      // paginationLayout: 'layout/paginationLayout',

      isMobile: 'layout/isMobile',
      is_screen_xs: 'layout/is_screen_xs',
      is_screen_sm: 'layout/is_screen_sm',
      is_screen_md: 'layout/is_screen_md',
      is_screen_lg: 'layout/is_screen_lg',
      is_labtop: 'layout/is_labtop',
    }),
    hasPermissionToEdit() {
      return new TransactionPermissions(this.currentUser).edit;
    },
    fields() {
      return fields;
    },
    isRTL() {
      return this.currentLanguageCode == 'ar'
    },
    pagesNumber () {
      return Math.ceil(this.rows.length / this.pagination.rowsPerPage)
    },
  },
  methods: {
    ...mapActions({
      doChangeSort: 'transaction/list/doChangeSort',
      doChangePaginationCurrentPage: 'transaction/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize: 'transaction/list/doChangePaginationPageSize',
      doMountTable: 'transaction/list/doMountTable',
      doFetch: 'transaction/list/doFetch',
    }),
    i18n(key, args) {
      return this.$t(key, args);
    },
    presenter(row, fieldName) {
      if (fieldName == 'accountType' || fieldName == 'payerType' || fieldName == 'payeeType' || fieldName == 'paymentMethod' || fieldName == 'status' || fieldName == 'type' || fieldName == 'operation') {
        return this.presenterEnum(row, fieldName)
      }
      const val = TransactionModel.presenter(row, fieldName);
      switch (fieldName) {
        case 'description':
          return val ? val[this.currentLanguageCode] : 'ـــ'
        case 'amount':
          return row['type'] == 'debit' 
            ? `${val * -1} ${this.currentLanguageCode == 'ar' ? 'ريال سعودي' : 'SAR'}` 
            : `${val} ${this.currentLanguageCode == 'ar' ? 'ريال سعودي' : 'SAR'}` 
        default:
          return val
      }
    },
    presenterEnum(row, fieldName) {
      const options = this.fields[fieldName].options;
      const val = options.filter(el => el.value == row[fieldName])
      return val.length ? this.i18n(val[0].i18n) : 'ـــ';
      // return val.length ? val[0].label : 'ـــ';
    },
    presenterMap(row, fieldName) {
      const val = TransactionModel.presenter(row, fieldName);
      return val[this.currentLanguageCode] ? val[this.currentLanguageCode] : 'ـــ'; 
    },
    presenterDateTime(row, fieldName) {
      const val = row[fieldName]
      return val ? moment(val).locale(this.currentLanguageCode).format("DD-MM-YYYY h:mm A") : 'ـــ'; 
    },
    presenterDate(row, fieldName) {
      const val = row[fieldName]
      return val ? moment(val).locale(this.currentLanguageCode).format("D MMM, YYYY") : 'ـــ'; 
    },
    presenterDay(row, fieldName) {
      const val = row[fieldName]
      return val ? moment(val).locale(this.currentLanguageCode).format("dddd") : 'ـــ'; 
    },
    presenterTime(row, fieldName) {
      const date = row[fieldName]
      return moment(date, "YYYY-MM-DD'T'hh:mm:ss.SSS'Z'").locale(this.currentLanguageCode).format('hh:mm a')
    },
    presenterTransaction(row, fieldName, key) {
      const user = TransactionModel.presenter(row, fieldName);
      if (key == 'avatars' || key == 'avatar') {
        let avatar = null
        if (user && Array.isArray(user[key])) {
          avatar = user[key].length ? user[key][0].publicUrl : null
        } else if (user && user[key]) {
          avatar = user[key].publicUrl 
        }
        return avatar ? avatar : 'https://firebasestorage.googleapis.com/v0/b/puricom-beebe.appspot.com/o/public%2Fdefault%2Favatar.svg?alt=media&token=439fb6e6-815f-453e-9e3a-79dc0ab3d40c'
      }
      return user && user[key] ? user[key] : 'ـــ'; 
    },
    presenterClient(row, fieldName, key) {
      const val = TransactionModel.presenter(row, fieldName);
      return val && val[key] ? val[key] : 'ـــ'; 
    },
    async doFilter() {
      return this.doFetch({
        filter: {},
      });
    },
  },
};
